import axios from 'axios';
import { getBackendHost } from '../utils/backendHost';


const authConfig = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('jwt_authorization')}` },
});


export async function validateCompInvitation(token) {
  const response = await axios.post(
    `${getBackendHost()}/v2/comp-invitations/validate`,
    { token },
  );
  return response.data;
}


export async function getCompInvitations() {
  const response = await axios.get(
    `${getBackendHost()}/v2/comp-invitations`,
    authConfig(),
  );
  return response.data.invitations || [];
}


export async function createCompInvitation(payload) {
  const response = await axios.post(
    `${getBackendHost()}/v2/comp-invitations`,
    payload,
    authConfig(),
  );
  return response.data;
}


export async function revokeCompInvitation(invitationId) {
  const response = await axios.delete(
    `${getBackendHost()}/v2/comp-invitations/${invitationId}`,
    authConfig(),
  );
  return response.data;
}
